export default __webpack_public_path__ + "static/solid-684a2fb6b72c8d10fdd7c38746f765d0.png";